// extracted by mini-css-extract-plugin
export default {"root":"XtP80FOn2t","avatarWrapper":"pPF3XHTbf2","message":"l8n1B8CSxT"};